














import Vue from "vue";

export interface FeatureItem {
  icon: string | undefined;
  title: string;
  text: string;
  color: string | undefined;
}

export default Vue.extend({
  name: "FeatureCard",
  props: {
    icon: String,
    title: String,
    text: String,
    color: String
  },
});
